import { createI18n } from 'vue-i18n';
import {messages} from './messages.js';

const i18n = createI18n({
    locale: navigator.language, 
    fallback: 'en',
    messages
});

export {i18n}